import { isArray } from 'underscore';

export function isNotEmptyArray(attributes) {
  return isArray(attributes) && attributes.length > 0;
}
